import { ComponentProps, FC } from 'react'
import { HexAlphaColorPicker, HexColorInput } from 'react-colorful'
import { twMerge } from 'tailwind-merge'
import Popover from 'shared/components/popover'

type ColorPickerProps = ComponentProps<typeof HexAlphaColorPicker>

const ColorPicker: FC<ColorPickerProps> = ({ color, className, ...rest }) => {
  return (
    <Popover
      label={
        <div className="flex flex-col gap-3">
          <HexAlphaColorPicker color={color} {...rest} />
          <div className="flex">
            <div className="rounded-l-lg bg-background-secondary p-2">#</div>
            <HexColorInput
              className="w-full rounded-r-lg border border-text-secondary/30 p-2 outline-hidden main-transition-colors focus:border-brand-primary"
              color={color}
              onChange={rest.onChange}
            />
          </div>
        </div>
      }
    >
      {() => (
        <div
          style={{ backgroundColor: color }}
          className={twMerge('size-10 rounded-full border border-text-secondary/90', className)}
        />
      )}
    </Popover>
  )
}

export default ColorPicker
